import React from 'react'
import TextInput from '../inputs/TextInput'

interface IdPropertyFieldProps {
  value: any
  onChange: (value: any) => void
  placeholder?: string
}

export default function IdPropertyField({ value, onChange, placeholder }: IdPropertyFieldProps) {
  const idValue = typeof value === 'string' ? value : value?.value || ''

  return (
    <div className="space-y-2">
      <TextInput
        value={idValue}
        onChange={(v) => onChange({ value: v })}
        placeholder={placeholder || 'Digite o ID'}
        type="text"
      />
    </div>
  )
}


